
export const useMainStore = defineStore("main", () => {
  const stretchHeader = ref(false);

  return { stretchHeader };
});
